import styled from 'styled-components';

import { Box, Text, Card, TextArea, Button } from '@gympass/yoga';

import { AlertIcon } from 'modals/Discharge/styles';

import { DrawerContentBoxListLiProps } from './types';

export const Container = styled(Box)``;

export const DrawerContentTitle = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.xxlarge}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xxlarge}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.stamina};
  flex: none;
  align-self: stretch;
`;

export const DrawerContentTitleUnavailable = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.xxlarge}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xxlarge}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.stamina};
  flex: none;
  align-self: stretch;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const DrawerContentSubTitle = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  color: ${({ theme }) => theme.yoga.colors.text.disabled};
  flex: none;
  align-self: stretch;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  width: 494px;
  ${({ bold, theme }) =>
    bold
      ? `font-weight: ${theme.yoga.fontWeights.medium};`
      : `font-weight: ${theme.yoga.fontWeights.regular};`};
`;

export const DrawerContainerBox = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 516px;
  height: 408px;
  flex: none;
  gap: ${({ theme }) => theme.yoga.spacing.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const DrawerContentBoxNotCritical = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  width: 520px;
  height: 44px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.tableBorder};
`;

export const CriticalBadge = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: none;
  box-shadow: none;
  width: fit-content;
  gap: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
  border-radius: ${({ theme }) => theme.yoga.radii.xsmall}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  ${({ isCritical, theme }) =>
    isCritical
      ? `background: ${theme.yoga.colors.feedback.attention.light};`
      : `background: ${theme.yoga.colors.disabled};`};
`;

export const IsSignalCriticalText = styled(Text)`
  overflow: hidden;
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.text.primary};
  border-radius: ${({ theme }) => theme.yoga.radii.xsmall}px;
`;

export const DrawerContentBoxIsCritical = styled(Box)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 520px;
  height: 340px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.tableBorder};
`;

export const RadioContent = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const DrawerContentBoxTitle = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  display: flex;
  align-items: center;
  ${({ isCritical, theme }) =>
    isCritical
      ? `color: ${theme.yoga.colors.stamina};`
      : `color: ${theme.yoga.colors.text.disabled};`};
`;

export const DrawerContentBoxListOl = styled.ol`
  list-style: none;
  margin: ${({ theme }) => theme.yoga.spacing.zero};
  padding-left: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const DrawerContentBoxListLi = styled.li<DrawerContentBoxListLiProps>`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  list-style: ${({ marker }) => marker};
  ${({ isCritical, theme }) =>
    isCritical
      ? `color: ${theme.yoga.colors.stamina};`
      : `color: ${theme.yoga.colors.text.disabled};`};
`;

export const TextAreaForward = styled(TextArea)`
  textarea {
    color: ${({ theme }) => theme.yoga.colors.stamina};
  }

  fieldset {
    ${({ value, theme }) =>
      value.length
        ? `border: ${theme.yoga.colors.inputDisabled}
        solid ${theme.yoga.borders.small}px;`
        : `border: ${theme.yoga.colors.error}
        solid ${theme.yoga.borders.small}px;`};
    min-height: ${({ theme }) => theme.yoga.sizes.textareaMinHeight}px;
    width: 520px;
  }
`;

export const NotificationBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: ${({ theme }) => theme.yoga.colors.attention};
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  width: 362px;
  height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.tableBorder};
`;

export const NotificationIcon = styled(AlertIcon)`
  width: ${({ theme }) => theme.yoga.sizes.small}px;
  height: ${({ theme }) => theme.yoga.sizes.small}px;
  fill: ${({ theme }) => theme.yoga.colors.stamina};
`;

export const NotificationText = styled(Text)`
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  color: ${({ theme }) => theme.yoga.colors.feedback.stamina};
`;

export const InformationText = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
  ${({ bold, theme }) =>
    bold
      ? `font-weight: ${theme.yoga.fontWeights.medium};`
      : `font-weight: ${theme.yoga.fontWeights.regular};`};
`;

export const InformationLink = styled(Button.Link)`
  display: inline;
  text-decoration: underline;
`;

export const DrawerBoxFooter = styled(Text.Tiny)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  color: ${({ theme }) => theme.yoga.colors.deep};
  margin-top: ${({ theme }) => theme.yoga.spacing.huge}px;
  bottom: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
`;
